import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const UserAvatar = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C8.28 2 2 8.28 2 16C2 23.72 8.28 30 16 30C23.72 30 30 23.72 30 16C30 8.28 23.72 2 16 2ZM16 4C22.617 4 28 9.383 28 16C28 18.34 27.326 20.526 26.163 22.373C24.656 20.778 22.825 19.579 20.806 18.844C21.558 17.508 22 15.835 22 13.999C22 10.691 19.308 7.999 16 7.999C12.692 7.999 10 10.691 10 13.999C10 15.835 10.442 17.508 11.194 18.844C9.175 19.579 7.344 20.778 5.837 22.373C4.674 20.525 4 18.34 4 16C4 9.383 9.383 4 16 4ZM12 14C12 11.794 13.794 10 16 10C18.206 10 20 11.794 20 14C20 17.364 18.243 20 16 20C13.757 20 12 17.364 12 14ZM16 28C12.453 28 9.261 26.452 7.062 23.997C8.54 22.343 10.412 21.154 12.487 20.523C13.469 21.455 14.678 22 16.001 22C17.324 22 18.533 21.455 19.515 20.523C21.59 21.154 23.462 22.343 24.94 23.997C22.741 26.452 19.549 28 16.002 28H16Z" />
	</svg>
);

export default UserAvatar;
